import React, { useState, useEffect } from "react";
import { Box, Button } from "@mui/material";
import { useApolloClient } from "@apollo/client";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { GET_CHILDREN_BY_PERSONAL_ID } from "./QueryPersonal";
import LoopIcon from '@mui/icons-material/Loop';
const ViewChildren = ({ id, params }) => {
  const { setAlertCustom, alertCustom, handleCloseModal } = params;
  const client = useApolloClient();
  const [visibility, setvisibility] = useState(false);
  const [childrenFicha, setchildrenFicha] = useState(null);
  useEffect(() => {
    const getchildrenFicha = async (id) => {
      try {
        const { data } = await client.query({
          query: GET_CHILDREN_BY_PERSONAL_ID,
          variables: {
            getChildrenByPersonalIdId: id,
          },
          fetchPolicy: "network-only",
        });        
        setchildrenFicha(data.getChildrenByPersonalId);
        setvisibility(true);
      } catch (error) {
        setAlertCustom({
          ...alertCustom,
          type: "error",
          message: error.message,
          state: true,
        });
      }
    };
    getchildrenFicha(id);
  }, []);

  return (
    visibility ? (
      <>
        {" "}
        <Box my={"20px"}>
          <TableContainer style={{ maxHeight: 550, overflowY: "auto" }}>
            <Table stickyHeader aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="">N°</TableCell>
                  <TableCell align="">NOMBRES</TableCell>
                  <TableCell align="">DNI</TableCell>
                  <TableCell align="">GENERO</TableCell>
                  <TableCell align="">FECHA DE NACIMIENTO</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {childrenFicha.map((row, index) => {
                  return (
                    <TableRow
                      key={row.id}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell align="">{index + 1}</TableCell>
                      <TableCell align="">
                        {row.name + " " + row.surname}
                      </TableCell>
                      <TableCell align="">{row.doi}</TableCell>
                      <TableCell align="">{row.gender.description}</TableCell>
                      <TableCell align="">
                        {new Date(row.dob).toLocaleDateString("es-ES")}
                      </TableCell>
                    </TableRow>
                    /* </RadioGroup> */
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
        <Box display={"flex"} justifyContent={"end"} marginTop={"30px"}>
          <Button variant="contained" onClick={handleCloseModal}>
            CERRAR
          </Button>
          {/*  */}
        </Box>
      </>
    ):<Box sx={{display:"flex",justifyContent:"center"}}><LoopIcon/></Box>
  );
};

export default ViewChildren;
